import { useEffect, useState } from "react";

// Gemeinsame FAQ (Drop-in für laclive.de) – holt die FAQ live von FoodBone
// und verlinkt zurück auf foodbone.com.
// TODO: Nach dem Deploy ggf. auf die Produktionsdomain lassen:
const FOODBONE_API = "https://foodbone.com"; // vorerst auch FoodBone-Preview-URL möglich
const ENDPOINT = `${FOODBONE_API}/api/shared-faq?site=laclive`;
const FETCH_TIMEOUT_MS = 5000;

export default function SharedFaq() {
  const [data, setData] = useState(null);
  const [active, setActive] = useState(null);
  const [openIdx, setOpenIdx] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    let didTimeout = false;
    const timeoutId = setTimeout(() => {
      didTimeout = true;
      controller.abort();
    }, FETCH_TIMEOUT_MS);

    fetch(ENDPOINT, { signal: controller.signal })
      .then((r) => {
        if (!r.ok) throw new Error("bad_status");
        return r.json();
      })
      .then((d) => {
        // Shape-Validierung: verhindert Render-Crash bei kaputtem Payload
        if (!d || !Array.isArray(d.faq) || !Array.isArray(d.categories)) {
          throw new Error("bad_shape");
        }
        setData(d);
        setActive(d.categories[0] || null);
      })
      .catch((err) => {
        // Ignore aborts caused by React StrictMode cleanup (only surface real failures)
        if (err && err.name === "AbortError" && !didTimeout) return;
        setError(true);
      })
      .finally(() => clearTimeout(timeoutId));

    return () => {
      clearTimeout(timeoutId);
      controller.abort();
    };
  }, []);

  // Fallback-UI bei Timeout, Netzwerkfehler oder ungültigem Payload
  if (error) {
    return (
      <section id="gemeinsame-faq" style={{ maxWidth: 760, margin: "0 auto", padding: "48px 16px" }}>
        <h2 style={{ fontSize: 30, fontWeight: 700, marginBottom: 8 }}>Gemeinsame FAQ mit FoodBone</h2>
        <p style={{ color: "#555", marginBottom: 16 }}>
          Die gemeinsame FAQ mit unserem Partner FoodBone ist gerade nicht erreichbar. Du findest die vollständige FAQ direkt auf FoodBone.
        </p>
        <a
          href="https://foodbone.com/#gemeinsame-faq"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex", alignItems: "center", gap: 8,
            padding: "10px 18px", borderRadius: 999,
            background: "#1E3F20", color: "#fff",
            textDecoration: "none", fontWeight: 600, fontSize: 14,
          }}
        >
          Zur FAQ auf FoodBone ↗
        </a>
      </section>
    );
  }
  if (!data) return <div style={{ padding: 24 }}>FAQ wird geladen …</div>;

  const items = data.faq.filter((f) => f.category === active);

  return (
    <section id="gemeinsame-faq" style={{ maxWidth: 760, margin: "0 auto", padding: "48px 16px" }}>
      <h2 style={{ fontSize: 30, fontWeight: 700, marginBottom: 8 }}>Häufig gestellte Fragen</h2>
      <p style={{ color: "#555", marginBottom: 20 }}>
        Gemeinsame FAQ von LacLive &amp; FoodBone – rund um Laktose, Milch, Darm und Knochen.
      </p>

      {/* Partner-Hinweis: Verlinkung zu FoodBone */}
      {data.partner && (
        <a
          href={data.partner.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12,
            textDecoration: "none", marginBottom: 24, padding: "14px 18px",
            borderRadius: 16, background: "#1E3F20", color: "#fff",
          }}
        >
          <span>
            <strong style={{ display: "block", fontSize: 15 }}>Partnerseite: {data.partner.name}</strong>
            <span style={{ fontSize: 13, color: "#C7D5C4" }}>{data.partner.tagline}</span>
          </span>
          <span style={{ fontWeight: 700, whiteSpace: "nowrap" }}>Besuchen ↗</span>
        </a>
      )}

      {/* Kategorie-Filter */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 20 }}>
        {data.categories.map((c) => (
          <button
            key={c}
            onClick={() => { setActive(c); setOpenIdx(null); }}
            style={{
              padding: "6px 16px", borderRadius: 999, fontSize: 14, cursor: "pointer",
              border: "1px solid #ddd",
              background: active === c ? "#1E3F20" : "#fff",
              color: active === c ? "#fff" : "#333",
            }}
          >
            {c}
          </button>
        ))}
      </div>

      {/* Akkordeon */}
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {items.map((item, i) => {
          const open = openIdx === i;
          return (
            <div key={i} style={{ border: "1px solid #e6e6e6", borderRadius: 16, background: "#fff", padding: "4px 18px" }}>
              <button
                onClick={() => setOpenIdx(open ? null : i)}
                style={{ width: "100%", textAlign: "left", padding: "16px 0", fontWeight: 600, fontSize: 16, background: "none", border: "none", cursor: "pointer" }}
              >
                {item.q}
              </button>
              {open && (
                <div style={{ paddingBottom: 18, color: "#444", lineHeight: 1.6 }}>
                  {item.a}
                  {item.link && (
                    <a
                      href={item.link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ display: "inline-block", marginTop: 12, color: "#C87D55", fontWeight: 600, textDecoration: "none" }}
                    >
                      {item.link.label} ↗
                    </a>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {data.attribution && (
        <p style={{ marginTop: 20, fontSize: 12, color: "#999" }}>
          <a href={data.attribution.url} target="_blank" rel="noopener noreferrer" style={{ color: "#999" }}>
            {data.attribution.label}
          </a>
        </p>
      )}
    </section>
  );
}
